/* A 16px glyph in a 20px hit box, muted until hovered or focused. */
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  inline-size: 20px;
  block-size: 20px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-small);
  background: transparent;
  color: var(--text-subtle);
  cursor: help;
  vertical-align: middle;
}

.button:hover {
  color: var(--text);
}

.button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 1px;
  color: var(--text);
}
